import React from 'react'

const Preloader = props => {
  const fullscreen = props.fullscreen ? 'spinner--fullscreen ' : ''
  return (
    <div className={fullscreen + (props.centered ? 'spinner--centered' : 'spinner')}>
      <div className={props.animated ? 'spinner__ball--animated' : 'spinner__ball'}></div>
    </div>
  )
}

export default Preloader
